"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerType = void 0;
var SearchDotted_svg_1 = __importDefault(require("@ClientAssets/icons/SearchDotted.svg"));
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_waypoint_1 = require("react-waypoint");
var SearchResultCard_1 = __importDefault(require("./SearchResultCard"));
var OnClickOutside_1 = __importDefault(require("CommonUI/OnClickOutside/OnClickOutside"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var StringManipulater_1 = require("Utils/StringManipulater");
var Telemetry_1 = require("Telemetry");
var TelemetryParameterValue_1 = require("Telemetry/TelemetryParameterValue");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var SearchDropdown = (function (_super) {
    __extends(SearchDropdown, _super);
    function SearchDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.openActionPanel = null;
        _this.searchTerm = "";
        _this.debouncedFetchSearchResults = (0, lodash_1.debounce)(_this.fetchSearchResults, 500);
        _this.handleSearchValueChange = function (value) {
            _this.searchTerm = value;
            _this.debouncedFetchSearchResults(value);
        };
        _this.handleViewChildren = function (project) {
            _this.closeProjectOptionMenu();
            _this.dashboardViewStore.setIsSearchDropdownOpen(false);
            _this.props.onViewChildren(project._id, project.name);
        };
        _this.listContainerRef = react_1.default.createRef();
        _this.onClickOutside = new OnClickOutside_1.default([".search-dropdown"], _this.clearSearch, setTimeout.bind(window), UniqueId_1.default);
        _this.searchStore = _this.props.searchStore;
        _this.dashboardViewStore = _this.props.dashboardViewStore;
        return _this;
    }
    SearchDropdown.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "search-dropdown" },
            react_1.default.createElement(kaleidoscope_2.SearchInput, { label: "Search pages", placeholder: "Search pages", value: this.searchTerm, onChange: this.handleSearchValueChange, onKeyDown: this.handleSearchKeyDown, onClear: this.handleSearchInputClear, "data-synthetics-selector": "search-pages-input" }),
            this.dashboardViewStore.isSearchDropdownOpen && this.renderResults()));
    };
    SearchDropdown.prototype.renderResults = function () {
        var _this = this;
        this.onClickOutside.startListening();
        var _a = this.searchStore, isLoadingResults = _a.isLoadingResults, results = _a.results;
        var isEmpty = results.length < 1;
        var scrollTop = !!this.listContainerRef.current ? this.listContainerRef.current.scrollTop : 0;
        var renderedResults = results.map(function (project) { return (react_1.default.createElement(SearchResultCard_1.default, { id: project._id, key: project._id, name: project.name, status: project.status, highlight: project.highlight, openProject: _this.openProject.bind(_this, project), editProject: _this.editProject.bind(_this, project), previewProject: _this.previewProject.bind(_this, project), cloneProject: _this.cloneProject.bind(_this, project), onOptionButtonClick: _this.openProjectOptionMenu.bind(_this, project), onOptionMenuClose: _this.closeProjectOptionMenu.bind(_this), scrollTop: scrollTop, isShowingOptions: _this.openActionPanel === project._id, hasTemplateChildren: project.hasTemplateChildren, templateParent: project.templateParent, onViewChildren: function () { return _this.handleViewChildren(project); } })); });
        var loadingOverlay = (react_1.default.createElement("div", { className: "search-dropdown__loader" },
            react_1.default.createElement(kaleidoscope_2.Spinner, { primary: true, size: "l" })));
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("search-dropdown__results", {
                "search-dropdown__results--empty": isEmpty,
            }), onScroll: this.closeProjectOptionMenu },
            !isLoadingResults && isEmpty && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.SVG, { className: "search-dotted-icon", src: SearchDotted_svg_1.default }),
                react_1.default.createElement("div", { className: "" }, "No pages match this term"))),
            react_1.default.createElement("div", { className: "search-dropdown__results-overflow", ref: this.listContainerRef },
                isLoadingResults && loadingOverlay,
                renderedResults,
                this.renderWaypoint()),
            !isEmpty && this.renderSeeAllResults()));
    };
    SearchDropdown.prototype.renderSeeAllResults = function () {
        var _this = this;
        var count = +this.searchStore.count;
        if (count > 8) {
            return (react_1.default.createElement("div", { className: "search-dropdown__see-all center", onClick: function () { return _this.props.displayAllResults(TriggerType.Click); } },
                react_1.default.createElement("span", { className: "label label--emerald label--large" },
                    "See All ",
                    (0, StringManipulater_1.pluralise)(count, "result")),
                react_1.default.createElement(icons_1.ArrowRight, null)));
        }
        else {
            return null;
        }
    };
    SearchDropdown.prototype.renderWaypoint = function () {
        if (!this.searchStore.isLoadingResults) {
            return react_1.default.createElement(react_waypoint_1.Waypoint, { onEnter: this.fetchMoreResults, bottomOffset: "-200px" });
        }
    };
    SearchDropdown.prototype.openProject = function (project) {
        this.props.projectService.open(project, Telemetry_1.ProjectOpenedOrigin.Search);
    };
    SearchDropdown.prototype.cloneProject = function (project) {
        this.props.projectService.clone(project, TelemetryParameterValue_1.ProjectCreatedCloneOrigin.SearchOptionsMenu);
    };
    SearchDropdown.prototype.editProject = function (project) {
        this.props.projectService.open(project, Telemetry_1.ProjectOpenedOrigin.SearchOptionsMenu);
    };
    SearchDropdown.prototype.previewProject = function (project) {
        return this.props.projectService.openCollaboratorPreview(project, TelemetryEnums_1.TelemetrySource.DashboardSearch);
    };
    SearchDropdown.prototype.openProjectOptionMenu = function (project) {
        if (this.openActionPanel) {
            this.openActionPanel = null;
        }
        else {
            this.openActionPanel = project._id;
        }
    };
    SearchDropdown.prototype.closeProjectOptionMenu = function () {
        this.openActionPanel = null;
    };
    SearchDropdown.prototype.fetchSearchResults = function (value) {
        this.searchStore.search(value);
        this.dashboardViewStore.setIsSearchDropdownOpen(true);
    };
    SearchDropdown.prototype.fetchMoreResults = function () {
        this.searchStore.search();
    };
    SearchDropdown.prototype.handleSearchInputClear = function () {
        this.searchTerm = "";
        this.debouncedFetchSearchResults("");
    };
    SearchDropdown.prototype.clearSearch = function () {
        if (this.dashboardViewStore.isSearchDropdownOpen) {
            this.searchStore.searchTerm = "";
        }
        this.dashboardViewStore.setIsSearchDropdownOpen(false);
    };
    SearchDropdown.prototype.handleSearchKeyDown = function (event) {
        var searchStore = this.props.searchStore;
        if (event.key === "Enter") {
            var shouldDisplayAllResults = !searchStore.isLoadingResults && searchStore.results.length > 0;
            if (shouldDisplayAllResults) {
                this.props.displayAllResults(TriggerType.Keyboard);
            }
        }
        if (event.keyCode === 27) {
            this.dashboardViewStore.setIsSearchDropdownOpen(false);
        }
    };
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SearchDropdown.prototype, "openActionPanel", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SearchDropdown.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "openProjectOptionMenu", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "closeProjectOptionMenu", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "fetchSearchResults", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "fetchMoreResults", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], SearchDropdown.prototype, "handleSearchValueChange", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "handleSearchInputClear", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "clearSearch", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof react_1.default !== "undefined" && react_1.default.KeyboardEvent) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], SearchDropdown.prototype, "handleSearchKeyDown", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SearchDropdown.prototype, "handleViewChildren", void 0);
    SearchDropdown = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SearchDropdown);
    return SearchDropdown;
}(react_1.default.Component));
exports.default = SearchDropdown;
var TriggerType;
(function (TriggerType) {
    TriggerType["Keyboard"] = "keyboard";
    TriggerType["Click"] = "click";
})(TriggerType || (exports.TriggerType = TriggerType = {}));
